import React from 'react'
import NavTitle from '../../../components/nav-title'
import TextNavTitle from '../../../components/TextNavTitle'
import NavRoleOrg from '../../../components/nav-role-org'
import { Link } from 'react-router-dom'
import { FaAngleRight } from 'react-icons/fa6'
import { PAGE_INCOME_PAYROLL } from '../../../router/routes'
import CardCustom from '../../../components/custom/card-custom'

export default function HistoryPayrollPage() {
  return (
    <div>
      <NavTitle>
        <TextNavTitle>
          <Link className="text-decoration-none" to={PAGE_INCOME_PAYROLL}>
            Payroll <FaAngleRight className="me-2" />
          </Link>
          <label className="small fw-medium">History</label>
        </TextNavTitle>
      </NavTitle>
      <NavRoleOrg />
      <CardCustom className="d-flex justify-content-between ">
        <div></div>
      </CardCustom>
    </div>
  )
}
